export default "__VITE_ASSET__BKKUU76j__"